<script setup lang="ts">
import { useWhatsAppButtonState } from '~/composables/useWhatsAppButtonState'

const route = useRoute()
const { isVisible: isWhatsAppButtonVisible } = useWhatsAppButtonState()

const isFooterVisible = computed(() => !route.meta.noFooter)
</script>

<template>
  <div class="flex min-h-screen flex-col">
    <RAppHeader />

    <main class="-mt-[6px] min-h-[400px] w-full overflow-hidden">
      <slot />
    </main>

    <ClientOnly>
      <RAppFooter v-if="isFooterVisible" />

      <div>
        <RFloatingWhatsappButton v-if="isWhatsAppButtonVisible" />
        <RFloatingShareOptionsButton v-if="route.meta.shareable" />
      </div>
    </ClientOnly>
  </div>
</template>
